import Notification from "components/helpers/notification";
import useAppContext from "lib/hooks/use-app-context";

const notice = "This subdomain is being deprecated. If it's still in use, please contact support@traitify.com for it to be restored.";

export default function Notice() {
  const {app} = useAppContext();
  const showNotice = app?.organization?.show_notice;

  if(!showNotice) { return; }

  return <Notification className="m-2" content={notice} type="error" />;
}
